<template>
    <div ref="pay-card-otp" id="pay-card-otp" class="opt-content-wrapper pay-pane active py-0">

        <!-- There are times where providers are unchecked from the Console,
        this hack is to display a message instead of showing just an empty
        blank white page.
    -->

        <!-- ========================== EMPTY ACTIONS ====================== -->
        <div class="modal-body pb-1" v-if="options == null">
            <div class="text-center mt-3">
                <div class="text-center">
                    <i class="title-icon warning"></i>
                </div>
                <h5 class="text-center mt-3 mb-5" style="line-height:1.5">No provider available for this payment option.
                    Kindly use other payment options</h5>
            </div>

            <div v-if="!loading && data.channels.length > 1" class="col-12 px-0 mt-4 text-center">
                <a href="javascript:void(0)" class="change-option" @click.prevent="changePaymentOption"> &larr; Choose
                    another method </a>
            </div>
        </div>
        <!-- ========================== EMPTY ACTIONS ====================== -->

        <!-- ========================== NOT EMPTY ====================== -->
        <div v-else>
            <!-- ========================== COMING SOON ====================== -->
            <div class="modal-body pb-1" v-if="current_option == null || isComingSoon">
                <div class="text-center mt-3">
                    <div class="modal-body text-center mb-4">
                        <!--h1 style="color: grey; width: 100%;">{{ data.option }}</-h1-->
                        <img v-if="current_option.image_url" :src="current_option.image_url" class="provider-logo" alt=""
                            style="width: 20%; height :auto" />
                        <h4 style="" class="mt-3 gray">Coming Soon</h4>
                        <p class="mt-3 mb-3" style="font-size:14px;"> <strong>{{ current_option.option }}</strong> is under
                            development, please use other payment method.</p>
                    </div>
                </div>

                <div v-if="!loading && data.channels.length > 1" class="col-12 px-0 mt-0 text-center">
                    <a v-if="options.length > 1" href="javascript:void(0)" class="text-tiny change-choice"
                        @click.prevent="goBack">Go Back </a> <br><br>
                    <a href="javascript:void(0)" class="change-option" @click.prevent="changePaymentOption"> &larr; Choose
                        another method </a>

                </div>
            </div>
            <!-- ========================== COMING SOON ====================== -->

            <!-- ========================== PROVIDER IS PRESENT ====================== -->
            <div v-else>

                <!-- Customer Processing Fees -->
                <p class="mt-3 bold" v-if="showProcessingFeeMessage.length > 0" v-html="showProcessingFeeMessage"> </p>
                <!-- Customer Processing Fees -->

                <div class="text-center mt-3" v-if="(current_option.provider || current_option.image_url) && !loading">
                    <img :src="current_option.image_url || `${(type === 'bank.account' ? '/img/banks' : '/img/')}/${current_option.provider.toLowerCase()}-logo.svg`"
                        class="provider-logo" alt="" />
                </div>

                <div class="modal-body pb-1">

                    <!-- Select TELCOS, BANK, WALLET VOUCHER -->
                    <div v-if="view == 'listings' && shouldShow" class="row mx-0">
                        <p class="text-center heading mt-3 mb-0" v-html="headingMessage"></p>
                        <div class="options-list">
                            <ul id="itemList" class="mx-0 mt-3 itemList px-0 v2-flex-container"
                                :style="data.channels.length > 4 ? '{ flex-wrap: wrap }' : ''">
                                <li class="app-text-color fg-1" @click.prevent="selectOption(key)" :key="item.option"
                                    :id="'list-' + key" v-for="(item, key) in chunk_items"
                                    :style="{ 'color': `${client_info.colors.app}` }">
                                    <img :src="item.image_url || `${(type === 'bank.account' ? '/img/banks' : '/img/')}/${item.provider.toLowerCase()}-logo.svg`"
                                        alt="" />
                                    <p class="title" @click.prevent="selectOption(key)"> {{ (item.option) }}</p>
                                </li>
                            </ul>
                        </div>

                        <!-- PAGINATOR -->
                        <div v-if="this.data.details.action.length > client_info.paginate_count">
                            <Paginator
                                v-if="client_info.paginate_count > 0 && client_info.paginate_count > options.length ? client_info.paginate_count : (options.length > 5)"
                                :per_page="client_info.paginate_count" :items="options" @next="handleNext"
                                @prev="handlePrev" :page="current_page" />
                        </div>

                    </div>
                    <!-- Select TELCOS, BANK, WALLET VOUCHER -->

                    <!-- ========================== VOUCHER ====================== -->
                    <div v-if="view == 'voucher'" class="row m-0 text-center">
                        <p v-if="!loading" class="heading" v-html="headingMessage"></p>

                        <div v-if="loading" class="py-5">
                            <Spinner class="my-2 animate slideInTop" :color="client_info.colors.app" />
                            <p>Please wait, validating ...</p>
                        </div>
                        <div v-else>
                            <div class="col-12 px-0">
                                <div class="form-group ">
                                    <form class="pay-otp-code" @submit.prevent="voucherPay">
                                        <input type="number" class="form-control no-label text-center"
                                            @keyup.enter="voucherPay" v-model="voucher_pin" id="voucherInput"
                                            ref="voucherInput" maxlength="11" autocomplete="off" minlength="4" autofocus
                                            required @focus="isFocus = true" @blur="isFocus = false"
                                            :style="{ borderColor: (isFocus ? appColor : '#e4e4e4') }"
                                            style="letter-spacing: 3px; font-size: 16px !important;" />
                                        <span class="invalid-feedback"
                                            :style="(errors.voucher) ? 'display : inline' : ''">{{ errors.voucher }}</span>
                                    </form>
                                </div>
                            </div>

                            <div v-if="!loading" class="col-12 px-0">
                                <div v-if="options.length > 1" class="form-group text-center mb-0">
                                    <a href="javascript:void(0)" class="text-tiny"
                                        @click.prevent="changeVoucherNetwork">&larr; {{ level1Change || 'Change Network'
                                        }}</a>
                                </div>
                                <div class="form-group mb-0 mt-4">
                                    <button type="submit" class="btn app-bg-color" :style="button_color"
                                        @click.prevent="voucherPay" @keyup.enter="voucherPay">Pay</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ========================== VOUCHER ====================== -->

                    <!-- ========================== AIRTIME/BANK.ACCOUNT ====================== -->
                    <div v-if="view == 'msisdn'" class="row m-0 text-center">

                        <p v-if="!loading && headingMessage" class="heading mt-0" v-html="headingMessage"></p>
                        <div v-if="loading" class="py-5">
                            <Spinner class="my-2 animate slideInTop" :color="client_info.colors.app" />
                            <p>Please wait, validating ...</p>
                        </div>

                        <div v-else>
                            <div class="col-12 px-0">
                                <div class="form-group ">
                                    <form class="pay-otp-code" @submit.prevent="getOtp">

                                        <!-- ACCOUNT NO. -->
                                        <input v-if="type == 'bank.account'" type="number" data-me
                                            class="form-control no-label text-center" @keyup.enter="getOtp" v-model="msisdn"
                                            id="msisdnInput" ref="msisdnInput" maxlength="10" autocomplete="off"
                                            minlength="9" autofocus required @focus="isFocus = true" @blur="isFocus = false"
                                            onKeyPress="if(this.value.length == 10) return false;"
                                            :style="{ borderColor: (isFocus ? appColor : '#e4e4e4') }" />

                                        <!-- MSISDN -->
                                        <input v-else type="number" class="form-control no-label text-center"
                                            @keyup.enter="getOtp" v-model="msisdn" id="msisdnInput" ref="msisdnInput"
                                            maxlength="11" autocomplete="off" minlength="4" autofocus required
                                            @focus="isFocus = true" @blur="isFocus = false"
                                            :style="{ borderColor: (isFocus ? appColor : '#e4e4e4') }"
                                            onKeyPress="if(this.value.length == 11) return false;" />

                                        <div v-if="show_bank_list" class="row mx-0 mt-3">
                                            <div class="col-12 px-0">
                                                <div class="form-group select-wrapper">
                                                    <select v-model="bank_code" class="form-control no-label py-3"
                                                        :style="{ borderColor: '#e4e4e4' }">
                                                        <option disabled value="">Choose your bank</option>
                                                        <option :value="bank.cbn_code" :key="key"
                                                            v-for="(bank, key) in banks">{{ bank.name }}</option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <span class="invalid-feedback" :style="(errors.msisdn) ? 'display : inline' : ''">{{
                                            errors.msisdn }}</span>
                                    </form>
                                </div>
                            </div>

                            <div v-if="!loading" class="col-12 px-0">
                                <div v-if="options.length > 1" class="form-group text-center mb-0">
                                    <a href="javascript:void(0)" class="text-tiny"
                                        @click.prevent="changeVoucherNetwork">&larr; {{ level1Change || 'Change' }}</a>
                                </div>
                                <div v-if="show_bank_list ? (bank_code !== '' && msisdn.length > 6 ? true : false) : true"
                                    class="form-group mb-0" :class="options.length > 1 ? 'mt-3' : 'mt-4'">
                                    <button type="submit" class="btn app-bg-color" :style="button_color"
                                        @click.prevent="getOtp" @keyup.enter="getOtp">Continue</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ========================== AIRTIME ====================== -->

                    <!-- ========================== OTP ====================== -->
                    <div v-if="view == 'otp'" class="row m-0">
                        <p v-if="!loading && headingMessage" class="heading mt-0"> {{ headingMessage }}</p>
                        <div v-if="loading" class="py-5">
                            <Spinner class="my-2 animate slideInTop" :color="client_info.colors.app" />
                            <p>Please wait, processing transaction</p>
                        </div>
                        <div v-else>
                            <div class="col-12 px-0">
                                <div class="form-group ">
                                    <form class="pay-otp-code" @submit.prevent="submitOtp">
                                        <!-- <input :type="showNum ? 'number' : 'text'" class="form-control no-label text-center" @keyup.enter="submitOtp" v-model="trx_otp" id="otpInput" ref="otpInput" :maxlength=" type == 'bank.account' ? '8' : '14'" autocomplete="off" minlength="4" autofocus required @focus="isFocus = true" @blur="isFocus = false" :style="{ borderColor: (isFocus ? appColor : '#e4e4e4')  }" /> -->

                                        <input :type="showNum ? (isOTP ? 'number' : 'password') : 'text'"
                                            class="form-control no-label text-center" @keyup.enter="submitOtp"
                                            v-model="trx_otp" id="otpInput" ref="otpInput"
                                            :maxlength="type == 'bank.account' ? (isOTP ? '8' : '25') : '10'"
                                            autocomplete="off" minlength="4" autofocus required @focus="isFocus = true"
                                            @blur="isFocus = false"
                                            :style="{ borderColor: (isFocus ? appColor : '#e4e4e4') }" />

                                        <span class="invalid-feedback"
                                            :style="(errors.trx_otp) ? 'display : inline' : ''">{{ otp_error_message
                                            }}</span>
                                    </form>
                                </div>
                            </div>

                            <div v-if="!loading" class="col-12 px-0">
                                <div v-if="!loading && this.data.details.action.length > 1"
                                    class="form-group text-left mb-0">
                                    <a href="javascript:void(0)" class="text-tiny gray col-8"
                                        @click.prevent="changePhoneAfterOtp">&larr; {{ level2Change || 'Change Phone Number'
                                        }}</a>

                                    <a href="javascript:void(0)" class="text-tiny gray col-4" style="float: right"
                                        @click.prevent="resendOtp"> {{ initialLegStatus === 'waitingforotp' ? 'Resend OTP' :
                                            'Resend' }} </a>
                                </div>

                                <div class="form-group mb-0 mt-4">
                                    <button type="submit" class="btn app-bg-color" :style="button_color"
                                        @click.prevent="submitOtp" @keyup.enter="submitOtp">Make Payment</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ========================== OTP ====================== -->

                    <!-- ========================== COUNTDOWN, NOINPUT USED FOR USSD VALIDATION/VERIFICATION ====================== -->
                    <div v-if="view == 'noinput-countdown'" class="row m-0 ">
                        <div v-if="loading" class="py-5">
                            <Spinner class="my-2 animate slideInTop" :color="client_info.colors.app" />
                            <p>Please wait, processing transaction</p>
                        </div>
                        <div v-else>

                            <p v-if="!loading" class="heading" v-html="headingMessage"></p>

                            <div class="col-12 px-0">
                                <p class="my-auto">Verifying Transaction in <strong><span class="text-black">{{
                                    countDownSeconds }} secs </span></strong> ....</p>
                            </div>
                        </div>
                    </div>
                    <!-- ========================== COUNTDOWN, NOINPUT USED FOR USSD VALIDATION/VERIFICATION ====================== -->

                </div>

                <div v-if="!loading && this.data.channels.length > 1" class="col-12 px-0 mt-4 text-center">
                    <a href="javascript:void(0)" class="change-option" @click.prevent="changePaymentOption"
                        title="Change payment method"> &larr; Choose another method </a>
                </div>
            </div>
        </div>
        <!-- ========================== NOT EMPTY ====================== -->
    </div>
</template>

<script>
/*
    This Page works with 
    Airtime, Voucher, Bank and Wallet Payment
*/

import axios from 'axios';
import Spinner from './includes/Spinner.vue'
import Paginator from './includes/Paginator.vue'
import {
    nibssBanks
} from './includes/banks.js';
// https://www.sitepoint.com/sort-an-array-of-objects-in-javascript/
// https://www.educative.io/edpresso/how-to-sort-an-array-of-objects-in-javascript

export default {

    name: 'airtime',
    props: ['data', 'appColor', 'client_info', 'button_color'],

    components: {
        Spinner,
        Paginator
    },

    created() {
        // console.log(this.data);
        // console.log(this.$store.state.transRef)

        // Show input page if provider is just one
        /* if(this.data.details.details === undefined){
            window.failedFromStartMessage = "No provider is set for this option from the option call.";
            window.failedFromStart = false;
            let raw  = JSON.parse(window.raw);
            raw.message = "No provider is set for this option from the option call.";
            window.raw = JSON.stringify(raw);
            this.$router.push('/v2/warning');
            return ;
        }else */

        this.type = this.data.details.auth_type.toLowerCase()

        switch (this.type) {
            case 'airtime':
                this.msisdn = this.$userFriendlyMsisdn(this.$store.state.payload.transaction.customer.mobile_no)
                this.level1Change = 'Change Network';
                this.level2Change = 'Change Phone Number';
                this.shouldShow = true;
                break;
            case 'bank.account':
                this.level1Change = 'Change Bank';
                this.level2Change = 'Change Account Number';
                this.shouldShow = true;
                break;

            case 'wallet':
                this.level1Change = 'Change Wallet Provider';
                this.level2Change = 'Change Wallet ID';
                this.shouldShow = true;
                break;

            case 'voucher':
                this.view = 'voucher';
                this.level1Change = 'Change Provider';
                this.level2Change = 'Change Wallet ID';
                this.shouldShow = true;
                break;

            default:
                break;
        }

        if (this.data.details.action.length === 0) {
            this.options = null;
            return;
        } else if (this.data.details.action.length === 1) {
            this.shouldShow = true;
            this.view = 'msisdn'
            this.options = this.data.details.action
            this.chunk_items = this.options.slice(0, 5);
            this.selectOption(0);
        } else if (this.data.details.action.length > 1) {
            this.shouldShow = true;
            this.view = 'listings'
            this.options = this.data.details.action
            this.headingMessage = this.data.details.message
            if (this.client_info.paginate_count && this.client_info.paginate_count > 0)
                this.chunk_items = this.options.slice(0, this.client_info.paginate_count > 0 ? this.client_info.paginate_count : 5);
            else
                this.chunk_items = this.options

            if (Object.keys(this.data.details).includes('provider_key')) // Handles default view
                this.selectOption([parseInt(this.data.details.provider_key)]);
        }

    },

    watch: {
        trx_otp(newVal) {
            if (this.errors.trx_otp) {
                this.errors.trx_otp = false;
                this.trx_otp = newVal;
            }
        },
        isFocus(newVal) {
            if (newVal)
                this.focusColor = this.appColor
        },

    },
    data() {
        return {
            // https://codepen.io/neil/pen/wLwVVB
            chunk_items: [],
            current_page: 0,
            isComingSoon: false,
            isOTP: true,
            trx_otp: '',
            account_name: '',
            otp_error_message: '',
            isFocus: true,
            view: 'listings',
            focusColor: '',
            showNum: true,
            msisdn: '',
            options: [],
            current_option: {},
            voucher_pin: '',
            loading: false,
            sendingOtp: false,
            countDownSeconds: 120,
            sendingPhone: false,
            level1Change: '',
            level2Change: '',
            headingMessage: '',
            shouldShow: false,
            type: '',
            initialLegStatus: 'waitingforotp',
            errors: {
                trx_otp: false,
            },
            show_bank_list: false,
            // banks: [],
            bank_code: '',
            showProcessingFeeMessage: '',
        }
    },
    methods: {
        changePaymentOption() {
            this.$parent.changeComponent("PaymentOptions");
            clearInterval(window.countDown);

            this.type = ''
            this.current_option = '';
            delete this.data.details.provider_key
            this.view = 'listings'
            this.isOTP = true;
            this.show_bank_list = false;

            // Generates  new Transaction ref while changing payment options that these points
            let criticalViews = ['otp', 'noinput-countdown'];
            if (criticalViews.indexOf(this.view)) {
                const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef()}`;
                this.$store.dispatch('transRef', newRef);
                this.$store.dispatch('isFailed', true);
            }

            this.$store.dispatch('customer_processing_fee', 0.00);
            this.showProcessingFeeMessage = '';
        },
        handlePrev(val) {
            this.chunk_items = val.data;
            this.current_page = val.page;
        },

        handleNext(val) {
            this.chunk_items = val.data;
            this.current_page = val.page;
        },

        goBack() {
            this.isComingSoon = false;
            this.headingMessage = this.data.details.message
            this.current_option = ''
            this.view = 'listings'
            this.show_bank_list = false;
            this.isOTP = true;
            this.$store.dispatch('customer_processing_fee', 0.00);
            this.showProcessingFeeMessage = '';
        },

        changeVoucherNetwork() {
            // console.log(this.data.details.message)
            this.headingMessage = this.data.details.message
            this.current_option = '';
            delete this.data.details.provider_key
            this.view = 'listings'
            this.isOTP = true;
            this.show_bank_list = false;
            this.$store.dispatch('customer_processing_fee', 0.00);
            this.showProcessingFeeMessage = '';
        },

        changePhoneAfterOtp() {
            this.headingMessage = this.data.details.message
            this.current_page = this.current_option.page;
            this.msisdn = '';
            this.view = 'msisdn'
            this.trx_otp = '';
            this.msisdn = '';
            this.show_bank_list = false;
            this.isOTP = true;
            // Generat a new Transaction ref, because the initial one has been usd on OnePipe.
            const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef()}`;
            this.$store.dispatch('transRef', newRef);
            this.$store.dispatch('isFailed', true);
            // this.$store.dispatch('customer_processing_fee', 0.00);

        },

        getInitialPayload() {
            let p = this.$parent.deepClone(this.$store.state.payload);
            delete p.hasTLSFallback
            delete p.referrer
            delete p.mode
            return p
        },

        selectOption(index) {
            const val = this.chunk_items[index]; // this.options[index];
            // console.log(val);
            // console.log(index);
            if (val) {
                this.current_option = val;
                this.current_option.page = this.current_page;

                /* if(val.extras && val.extras.customer_processing_fee && val.extras.customer_processing_fee > 0){
                    this.$store.dispatch('customer_processing_fee', val.extras.customer_processing_fee);
                } */

                if (Object.keys(val).includes('extras') && val.extras != null) {
                    if (val.extras.customer_processing_fee_flat && parseFloat(val.extras.customer_processing_fee_flat) > 0) {
                        let fees = parseFloat(val.extras.customer_processing_fee_flat);
                        this.$store.dispatch('customer_processing_fee', fees.toFixed(2));
                        this.showProcessingFeeMessage = ` A surcharge of <strong>₦${fees.toFixed(2)}</strong> has been added to your payment. `
                    } else if (val.extras.customer_processing_fee_percentage && parseFloat(val.extras.customer_processing_fee_percentage) > 0) {
                        let percentage_price_as_flat = (parseFloat(this.getInitialPayload().transaction.amount) / 100) * (parseFloat(val.extras.customer_processing_fee_percentage) / 100)
                        this.$store.dispatch('customer_processing_fee', percentage_price_as_flat.toFixed(2));
                        this.showProcessingFeeMessage = ` A surcharge of <strong>₦${percentage_price_as_flat.toFixed(2)}</strong> has been added to your payment. `
                    }
                }

                if (val.provider && (val.provider !== null || val.provider !== "")) {
                    if (val.provider.toLowerCase() === "comingsoon") { // Show coming soon
                        this.isComingSoon = true;
                    } else { // Is Present
                        // this.headingMessage = this.current_option.instructions || (this.type == 'bank.account' ? 'Enter your account number' : 'Enter your msisdn');
                        this.headingMessage = val.instructions;
                        if (this.type === 'airtime') {
                            this.msisdn = this.$userFriendlyMsisdn(this.$store.state.payload.transaction.customer.mobile_no)
                        }

                        let extras = this.current_option.extras
                        if (Object.keys(extras).includes('show_bank_list') && extras.show_bank_list !== null && extras.show_bank_list.toLowerCase() === "true") {
                            this.show_bank_list = true;
                            let sortedBanks = nibssBanks.sort(this.$sortCompare)
                            this.banks = sortedBanks;
                        }

                        this.view = 'msisdn'
                    }
                }
                /* else {
                                   console.log("Provider is empty")
                                   // look at the instructions
                               } */
            }
            /* else {
                           this.isComingSoon = true;
                           // console.log("Senior Coming Soon")
                       } */

        },

        resendOtp() {
            const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef()}`;
            this.$store.dispatch('transRef', newRef);
            this.$store.dispatch('isFailed', true);
            this.getOtp();
        },

        timeoutCountdown() {
            window.countDown = setInterval(() => {
                this.countDownSeconds--
                if (this.countDownSeconds <= 0) {
                    clearInterval(window.countDown);
                    this.lookupPendingTransactionAfterCountDown();
                    return;
                }
            }, 1000);

        },

        lookupPendingTransactionAfterCountDown() {
            this.loading = true;

            // let initialPayload = this.getInitialPayload(),
            let payload = {
                request_ref: this.$generateRequestRef(),
                request_type: this.$store.state.payload.request_type,
                auth: {
                    secure: this.msisdn,
                    auth_provider: this.current_option.provider
                },
                transaction: {
                    transaction_ref: this.$store.state.transRef
                }
            };

            if (this.$store.state.isFailed) {
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef
            }

            payload.transaction.transaction_ref = this.$store.state.transRef

            let data2 = {
                endpoint: 'validate',
                api_key: this.$store.state.api_key,
                payload,
            },
                data = this.$generateToken(data2);

            // console.log(JSON.stringify(data2));
            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data,
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }
            }).then(response => {

                let hash = response.data.data,
                    res = this.$decodeToken(hash),
                    status = res.status.toLowerCase(),
                    message = res.message,
                    responseData = res.data;
                // console.log(res);
                window.raw = JSON.stringify(res);

                if (response.status === 200) {

                    this.loading = false;

                    if (status == "successful") {
                        this.loading = false;

                        // Check if user set close_popup for card to onSuccess
                        // let payload = this.$store.state.payload
                        if (this.type == 'wallet') {
                            this.$parent.changeComponent('Status', {
                                transRef: this.$store.state.transRef,
                                type: 'Successful',
                                data: responseData.data,
                                message: message
                            });
                        }

                    } else {
                        this.loading = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage = res.message;
                        this.$router.push('/v2/warning');
                    }
                } else {
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                }
            })
                .catch(error => {
                    // console.log(error)
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                })

        },

        voucherPay() {
            this.errors.voucher = ''
            if (this.voucher_pin.length < 11) {
                this.errors.voucher = "Please supply a valid voucher pin.";
                this.$refs.voucherInput.focus();
                return;
            }

            this.loading = true;

            let initialPayload = this.getInitialPayload()
            let randomId = this.$generateRequestRef(),
                payload = initialPayload;

            payload.auth = {
                type: this.type,
                secure: this.voucher_pin,
                auth_provider: this.current_option.provider
            }

            payload.request_ref = randomId;

            if (payload.transaction.meta) {
                payload.transaction.meta.telco = this.current_option.provider
            } else
                payload.transaction.meta = {
                    telco: this.current_option.provider,
                }

            if (this.$store.state.isFailed) {
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef
            }

            payload.transaction.transaction_ref = this.$store.state.transRef

            let data2 = {
                api_key: this.$store.state.api_key,
                endpoint: 'transact',
                payload
            },
                data = this.$generateToken(data2);

            delete data2.payload.api_key
            // console.log(JSON.stringify(data))
            // console.log(JSON.stringify(data2))

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data,
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }
            }).then(response => {
                let hash = response.data.data,
                    res = this.$decodeToken(hash),
                    status = res.status.toLowerCase(),
                    message = res.message;
                // responseData = res.data;
                // console.log(res);
                window.raw = JSON.stringify(res);

                if (response.status === 200) {

                    if (status == "successful") {
                        this.loading = false;
                        this.$parent.changeComponent('Status', {
                            transRef: this.$store.state.transRef,
                            type: 'Successful',
                            data: res,
                            message: message
                        });
                    } else {
                        this.loading = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage = res.message;
                        this.$router.push('/v2/warning');
                    }
                } else {
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                }
            })
                .catch(error => {
                    // console.log(error)
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                })
        },

        getOtp() {
            this.errors.msisdn = ''
            let secure = '';

            if (this.type == "airtime") {
                if (this.msisdn.length < 11) {
                    this.errors.msisdn = "Please supply a valid item.";
                    this.$refs.msisdnInput.focus();
                    return;
                }

                secure = this.msisdn;
            }

            if (this.type == "bank.account") {
                if (this.msisdn.length < 10) {
                    this.errors.msisdn = "Please supply a valid account number.";
                    this.$refs.msisdnInput.focus();
                    return;
                }

                if (Object.keys(this.current_option.extras).includes('bank_code')) {
                    secure = `${this.msisdn};${this.current_option.extras.bank_code}`;
                } else {
                    if (this.show_bank_list) {
                        secure = `${this.msisdn};${this.bank_code}`;
                    } else {
                        secure = this.msisdn;
                    }
                }

            }

            this.loading = true;

            let initialPayload = this.getInitialPayload()
            let randomId = this.$generateRequestRef(),
                payload = initialPayload;

            payload.auth = {
                type: this.type,
                secure: secure,
                auth_provider: this.current_option.provider
            }

            payload.request_ref = randomId;

            switch (this.type) {
                case 'voucher':
                default:
                    if (payload.transaction.meta) {
                        payload.transaction.meta.current_option = this.current_option.provider
                    } else
                        payload.transaction.meta = {
                            current_option: this.current_option.provider.toLowerCase(),
                        }
                    break;

                case 'airtime':
                    if (payload.transaction.meta) {
                        payload.transaction.meta.current_option = this.current_option.provider
                    } else {
                        payload.transaction.meta = {
                            current_option: this.current_option.provider,
                        }
                    }
                    break;
                case 'bank.account':

                    break;

                case 'wallet':
                    break;
            }

            if (this.$store.state.isFailed) {
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef
            }

            payload.transaction.transaction_ref = this.$store.state.transRef

            // add customer_processing_fees
            if (this.$store.state.customer_processing_fee) {
                payload.transaction.amount = parseInt(payload.transaction.amount) + parseInt(this.$store.state.customer_processing_fee.toString().replace('.', ''));
            }

            let data2 = {
                api_key: this.$store.state.api_key,
                endpoint: 'transact',
                payload
            },
                data = this.$generateToken(data2);

            delete data2.payload.api_key
            // console.log(JSON.stringify(data))
            // console.log(JSON.stringify(data2))
            // console.log(payload);

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data,
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }
            }).then(response => {
                let hash = response.data.data,
                    res = this.$decodeToken(hash),
                    status = res.status.toLowerCase(),
                    message = res.message,
                    responseData = res.data;
                // console.log(res);
                window.raw = JSON.stringify(res);

                if (response.status === 200) {

                    if (["successful", "processing"].includes(status)) {
                        this.loading = false;

                        // Check if user set close_popup for card to onSuccess
                        let payload = this.$store.state.payload;
                        this.$parent.changeComponent('Status', {
                            reference: payload.transRef,
                            data: responseData,
                            type: status == 'successful' ? 'Successful' : 'Processing',
                            message: message || res.data.message
                        });

                    } else if (["pendingfulfilment","pendingfulfillment", "waitingforotp", "pendingvalidation"].includes(status)) {
                        this.loading = false;
                        if (this.type == "wallet" && responseData.provider_response.no_input) {
                            this.headingMessage = message
                            this.view = 'noinput-countdown'
                            this.countDownSeconds = responseData.provider_response.count_down_timeout;

                            // start countdown in 5 secs
                            setTimeout(() => {
                                this.timeoutCountdown();
                            }, 2000);
                        } else if (this.type == "bank.account" && status == 'pendingfulfilment') {
                            this.$parent.changeComponent('Status', {
                                reference: payload.transRef,
                                data: responseData,
                                type: 'PendingFulfilment',
                                message: message || res.data.message
                            });
                        } else {
                            this.view = 'otp'
                            this.headingMessage = message || `Enter otp sent to ${this.$maskPhone(this.msisdn)}`
                            if (status == "pendingvalidation") {
                                this.isOTP = false;
                                this.initialLegStatus = status
                            }
                        }

                        return;
                    } else {
                        this.$store.dispatch('customer_processing_fee', 0.00);
                        this.loading = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage = res.message;
                        this.$router.push('/v2/warning');
                    }
                } else {
                    this.$store.dispatch('customer_processing_fee', 0.00);
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                }
            })
                .catch(error => {
                    this.$store.dispatch('customer_processing_fee', 0.00);
                    // console.log(error)
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                })
        },

        submitOtp() {

            if (this.trx_otp.length <= 3) {
                this.errors.trx_otp = true;
                this.otp_error_message = "Please supply OTP code.";
                this.$refs.otpInput.focus();
                return;
            }

            this.loading = true;

            let initialPayload = this.getInitialPayload(),
                payload = {
                    request_ref: this.$generateRequestRef(),
                    request_type: initialPayload.request_type,
                    auth: {
                        secure: this.trx_otp,
                        auth_provider: this.current_option.provider
                    },
                    transaction: {
                        transaction_ref: this.$store.state.transRef
                    }
                };

            if (this.$store.state.isFailed) {
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef
            }

            let data2 = {
                endpoint: 'validate',
                api_key: this.$store.state.api_key,
                payload,
            },
                data = this.$generateToken(data2);

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data,
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }
            }).then(response => {

                let hash = response.data.data,
                    res = this.$decodeToken(hash),
                    status = res.status.toLowerCase(),
                    message = res.message,
                    responseData = res.data;
                // console.log(res);
                window.raw = JSON.stringify(res);

                if (response.status === 200) {
                    if (status == "successful") {
                        this.loading = false;
                        this.mPassLoadingMessage = "";
                        this.$parent.changeComponent('Status', {
                            transRef: this.$store.state.transRef,
                            type: 'Successful',
                            status: 'Successful',
                            data: responseData,
                            message: message
                        });

                    } else {

                        this.$store.dispatch('customer_processing_fee', 0.00);

                        this.loading = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage = res.message;
                        this.$router.push('/v2/warning');
                    }
                } else {
                    this.$store.dispatch('customer_processing_fee', 0.00);
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                }
            })
                .catch(error => {
                    this.$store.dispatch('customer_processing_fee', 0.00);
                    // console.log(error)
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                })
        }
    }
};
</script>

<style scoped>
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.v2-flex-container {
    display: flex !important;
    flex-flow: column wrap;
    transition: all .5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    border: solid 1px #ccc;
    border-radius: 5px;
    border-bottom: none;
    /* filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.6)); */
    webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);

}

ul.v2-flex-container li {
    list-style-type: none;
    height: 40px;
    cursor: pointer;
    background: #f5f5f578;
    font-size: 12px;
    padding: 8px 0px 8px 0px;
    width: 100%;
    border-bottom: #ded8d8 solid 1px;
    line-height: 40px;
    text-align: left;
}

/* border-radius: 5px 5px 0px 0px; */

ul.v2-flex-container li:first-child {
    border-radius: 5px 5px 0px 0px
}

ul.v2-flex-container li:last-child {
    /* border-bottom: none; */
    border-radius: 0px 0px 5px 5px;
}

ul.v2-flex-container li:hover,
ul.v2-flex-container li:focus {
    background: #e4e4e4;
    color: #000000 !important;
    margin-right: 30px;
}

ul.v2-flex-container li>p:hover,
ul.v2-flex-container li>p:focus {
    color: #000000;
}

ul.v2-flex-container li img {
    height: 30px;
    width: 30px;
    line-height: 30px;
    padding-left: 15px;
    margin-right: 10px;
    vertical-align: middle;
}

.options-list ul li p {
    font-weight: 600;
    vertical-align: middle;
    margin: 0%;
    display: inline-block;
    height: 40px;
    line-height: 40px;
    text-align: left;
}

ul.v2-flex-container li::after {
    content: "\203A";
    font-weight: 300;
    font-size: 25px;
    float: right;
    margin-right: 15px;
}

.provider-logo {
    height: 50px;
    width: auto;
    margin-bottom: 20px;
}

.heading {
    text-align: center;
    width: 100%;
}
</style>
